module.exports = __webpack_public_path__ + "images/thumb-516d2f2bfb9cec8e535590f40bdd0627.jpg";